import { odinClient } from "@/config/client"

export interface Feedback {
  bullets: string[]
  approvalScore: number
  scorePercentage: number
}

export interface NextQuestionFlashcard {
  index: number
  question: string
  answer: string
}

export interface FlashcardActivity {
  id: string
  more: boolean
  next: NextQuestionFlashcard
  total: number
  current: number
  feedback: Feedback
}

export interface UpdateStudySessionResponse {
  description: FlashcardActivity
}

interface UpdateStudySessionData {
  confidence?: number
  elapsedTimeInSeconds?: number
}

export function update(sessionId: string, activityId: string, data: UpdateStudySessionData) {
  return odinClient.put<UpdateStudySessionResponse, UpdateStudySessionData>(
    `/v1/activities/${activityId}/flashcards/study-session/${sessionId}`,
    data,
  )
}
